import React, { useState, useEffect } from "react";
// import swal from "sweetalert";
import Skeleton from "react-loading-skeleton";
// import moment from "moment";

function TotalRecords(props) {
  const badgePath = props.url || `/api/dashboard/statistics/${props.type}.json`;
  const [totalCount, setTotalCount] = useState();
  const [change, setChange] = useState(null);
  const [changeLabel, setChangeLabel] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const formattedTotal = (() => {
    if (totalCount === null || totalCount === undefined || totalCount === "") {
      return "-";
    }

    const numericValue = Number(totalCount);
    if (Number.isFinite(numericValue)) {
      return numericValue.toLocaleString();
    }

    return totalCount;
  })();

  const fetchTotalRecord = () => {
    setIsLoading(true);
    fetch(badgePath)
      .then((res) => (res && res.status ? res.json() : Promise.reject(res)))
      .then((res) => {
        if (res) {
          setTotalCount(res.total);
          setChange(res.change);
          setChangeLabel(res.change_label);
        }
      })
      .catch((err) =>
        console.log("Terjadi kesalahan saat mengambil data temu janji")
      )
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    // setInterval(function(){ fetchTotalRecord(); }, 10000);
    fetchTotalRecord();
  }, []);

  const LABELS = {
    vs_yesterday: "vs yesterday",
    this_month: "this month",
  };

  const renderChange = () => {
    if (change === null || change === undefined || !changeLabel) return null;
    const num = Number(change);
    if (!Number.isFinite(num)) return null;

    const icon = num > 0
      ? "zmdi-trending-up"
      : num < 0
        ? "zmdi-trending-down"
        : "zmdi-trending-flat";
    const sign = num > 0 ? "+" : "";
    const label = LABELS[changeLabel] || "";

    return (
      <span className="dash-stat-card__change">
        <i className={`zmdi ${icon}`} /> {sign}{num.toLocaleString()} {label}
      </span>
    );
  };

  return (
    <div>
      {isLoading ? (
        <div>
          <h2><Skeleton height={20} width={30} /></h2>
        </div>
      ) : (
        <div className="d-flex align-items-baseline">
          <h2>{formattedTotal}</h2>
          {renderChange()}
        </div>
      )}
    </div>
  );
}

export default TotalRecords;
